// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"205":"15bc1b6d","268":"1f22df59","333":"e4f4fb97","364":"61e0ecf6","525":"15bc1b6d","923":"603f8e17","983":"4678ff12"}[chunkId] + ".chunk.css";
};